// disable auto-story
import { Navbar } from '@nrdy-marketing-engine/navbar';
import NerdyHead from '@nrdy-marketing-engine/nerdy-head/src/nerdy-head';
import { PathProvider } from '@nrdy-marketing-engine/routing';
import { Theme } from '@nrdy-marketing-engine/theming';
import Script from 'next/script';
import { LayoutProps } from '../@types/schema';
import { useFixedNavbar } from '@nrdy-marketing-engine/use-fixed-navbar';
import useNavbarHeightObserver from './use-navbar-height-observer';
import clsx from 'clsx';

function SetVerticalHeightScript() {
  const script = `
    var fn = () => { document.documentElement.style.setProperty("--vh", window.innerHeight + 'px'); };
    window.addEventListener('resize', fn, { passive: true });
    fn();
  `;

  return (
    <Script id="setVerticalHeight" strategy="afterInteractive">
      {script}
    </Script>
  );
}

/**
 * Represents a container component that sets up a regular page layout for a document.
 */
const Layout = ({
  children,
  hideFooter,
  hideNavbar,
  metadata,
  path,
  renderFooter: Footer,
  theme,
}: LayoutProps) => {
  const isFixed = useFixedNavbar();
  const headerRef = useNavbarHeightObserver();

  return (
    <>
      <PathProvider path={path}>
        <NerdyHead metadata={metadata} />
        <SetVerticalHeightScript />
        <Theme className="flex flex-col min-h-screen" theme={theme}>
          {!hideNavbar && (
            <header className={clsx('w-full', isFixed && 'sticky top-0 z-10')} ref={headerRef}>
              <Navbar />
            </header>
          )}

          {children}

          {!hideFooter && Footer && <Footer />}
        </Theme>
        <div id="drawer" />
      </PathProvider>
    </>
  );
};

export default Layout;
